import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const AdvertisingBanner = () => {
  const navigate = useNavigate();

  return (
    <section className="relative py-20 overflow-hidden" style={{ backgroundColor: '#DE92A9' }}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1519741497674-611481863552?w=1920&h=400&fit=crop&q=80")',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          <h2 
            className="text-4xl md:text-5xl text-white mb-6 tracking-tight"
            style={{ fontFamily: '"Playfair Display", serif' }}
          >
            Getting Married in Malta?
          </h2>
          <p className="text-white/90 text-lg md:text-xl leading-relaxed mb-8 max-w-3xl mx-auto">
            Discover Malta's finest wedding suppliers, venues, and services. Let us help you create your perfect day.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              onClick={() => navigate('/advertise')}
              className="bg-white hover:bg-[#FAF9F7] px-8 py-6 text-sm tracking-wider h-auto rounded group transition-all duration-300 shadow-lg"
              style={{ color: '#DE92A9' }}
            >
              ADVERTISE WITH US
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
            </Button>
            <Button 
              onClick={() => navigate('/partners')}
              variant="outline"
              className="border-2 border-white text-white hover:bg-white px-8 py-6 text-sm tracking-wider h-auto rounded transition-all duration-300"
              style={{ '--hover-color': '#DE92A9' }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#DE92A9'}
              onMouseLeave={(e) => e.currentTarget.style.color = 'white'}
            >
              FIND SUPPLIERS
            </Button>
          </div>

          {/* Stats */}
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-4xl font-light text-white mb-2" style={{ fontFamily: '"Playfair Display", serif' }}>97</div>
              <div className="text-white/80 text-sm tracking-wider">ISSUES PUBLISHED</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-light text-white mb-2" style={{ fontFamily: '"Playfair Display", serif' }}>10+</div>
              <div className="text-white/80 text-sm tracking-wider">YEARS OF EXCELLENCE</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-light text-white mb-2" style={{ fontFamily: '"Playfair Display", serif' }}>1000s</div>
              <div className="text-white/80 text-sm tracking-wider">COUPLES HELPED</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvertisingBanner;